


















































































import { defineComponent, PropType, computed } from "@nuxtjs/composition-api";
import VueBarcode from "vue-barcode";
import { copyCode, nl2br } from "~/helpers";
import { Voucher } from "~/composables/useVoucher/useVoucher";
import { useUiNotification } from "~/composables";
import { setTitleVoucher,getDaysUntilExpiry,getCurrentTime } from "~/helpers";

export default defineComponent({
  name: "VoucherDetailModal",
  components: {
    VueBarcode,
  },
  props: {
    isModalVoucher: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object as PropType<Voucher>,
      required: true,
    },
    position: {
      type: String,
      required: false,
    },
  },
  setup(props, { root, emit }) {
    const itemDetail = computed(() => props.item as Voucher);
    const { send: sendNotification } = useUiNotification();

    const titleVoucher = (item: Voucher) => {
      return setTitleVoucher(item);
    };

    const saveVoucher = () => {
      emit("saveVoucher", props.item);
    };

    const closeModal = () => {
      emit("close");
    };
    const goToLink = (urlPath: string) => {
      root.$router.push(urlPath);
    };

    const handleCopyCode = (voucher: Voucher) => {
      let code = voucher?.voucher_id
        ? voucher?.voucher_id
        : voucher?.counpon_code;
      let message = `Bạn đã copy mã ${code}`;
      copyCode(code);

      sendNotification({
        id: Symbol("copy_text_success"),
        message: message,
        type: "success",
        icon: "check",
        persist: false,
        title: message,
      });
    };

    return {
      titleVoucher,
      copyCode,
      nl2br,
      goToLink,
      saveVoucher,
      closeModal,
      itemDetail,
      handleCopyCode,
      getCurrentTime,
      getDaysUntilExpiry
    };
  },
});
